import { apiFetch, readJson } from './client';
import type { ListSyncRunsOptions, SyncRun, SyncRunListPage } from './syncJobs';

export async function listPeopleSyncRuns(
  opts: Omit<ListSyncRunsOptions, 'jobName'> = {}
): Promise<SyncRunListPage> {
  const params = Object.entries(opts)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  const qs = params.length === 0 ? '' : `?${params.join('&')}`;
  const res = await apiFetch(`/api/admin/people-sync/sync-runs${qs}`);
  if (!res.ok) throw new Error(`Failed to list people sync runs: ${res.status}`);
  return readJson<SyncRunListPage>(res);
}

export async function getPeopleSyncRun(id: string): Promise<SyncRun> {
  const res = await apiFetch(`/api/admin/people-sync/sync-runs/${encodeURIComponent(id)}`);
  if (!res.ok) throw new Error(`Failed to load people sync run: ${res.status}`);
  return readJson<SyncRun>(res);
}
